// reducers/counterReducer.js
import {createSlice} from '@reduxjs/toolkit'
const filterBuyerCode = createSlice({
  name: 'filterBuyerCode',
  initialState: [] as any,
  reducers: {
    buyerCodeFilterdata(state:any, action:any) {
   if(action?.payload && action.payload.length > 0){
    return action.payload
   }else{
    return []
   }
    },
  },
})
export default filterBuyerCode.reducer
export const {buyerCodeFilterdata} = filterBuyerCode.actions
